/***
**Module Name: View user
 **File Name :  View.js
 **Project :    Orasi Media
 **Copyright(c) : X Platform Consulting.
 **Organization : Peafowl Inc
 **author :  chandrasekhar
 **author :  Hari
 **license :
 **version :  1.0.0
 **Created on :
 **Created on: Dec 29 2022
 **Last modified on: Dec 29 2022
 **Description : contains add user details.
 ***/
import React, { useState, useEffect, useContext } from "react";
import Footer from "../../components/dashboard/footer";
import Header from "../../components/dashboard/header";
import Sidebar from "../../components/dashboard/sidebar";
import tmdbApi from "../../api/tmdbApi";
import SweetAlert from 'react-bootstrap-sweetalert';
import moment from "moment";
import { useHistory, useLocation, useParams } from "react-router-dom";
import { contentContext } from "../../context/contentContext";
import axios from 'axios';
import DataTable from 'react-data-table-component';
import parse from "react-html-parser";
let { appname, lambda, country } = window.app;


const View = () => {
    const history = useHistory();
    const { state } = useLocation();
    let { quizid } = useParams();
    // const { quizinfo } = state || {};

    const [files, setFiles] = useState([]);
    const [imagedisplay, setImageDisplay] = useState(false);
    const [announceWinnerPopup, setAWPopup] = useState(false);
    const [announceWinnerResult, setAWResult] = useState([]);
    const [viewResult, setViewResult] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);

    const [success, setSuccess] = useState(false);
    const [updatesuccess, setUpdateSuccess] = useState(false);
    const [viewParticipant, setViewParticipant] = useState({});
    const [toggleClearRows, setToggleClearRows] = useState(false);
    const [imageCloudfront, setImg] = useState(false);
    const [quizinfo, setQuizInfo] = useState(null);

    const [formData, setFormData] = useState({
        name: quizinfo?.name,
       // startDate: quizinfo?.startDate?.length > 16 ? quizinfo?.startDate.slice(0, -8) : quizinfo?.startDate,
        endDate: quizinfo?.endDate?.length > 16 ? quizinfo?.endDate.slice(0, -8) : quizinfo?.endDate,
        quizType: quizinfo?.quizType,
        status: quizinfo?.status
    });
    const [errorData, setError] = useState({});
    const [errorDisplay, seterrorDisplay] = useState(false);

    const { route, setRoute, setCurrentPage, setRowsPerPage, usePrevious, setActiveMenuObj, setActiveMenuId, GetTimeActivity } = useContext(contentContext);


    const columns = [

        {
            name: 'Name',
            selector: row => row?.participationDetails?.name ?? "",
            sortable: true,
        },
        {
            name: 'Score',

            cell: (props) =>
                <div className="d-flex">
                    {props?.correctAnswers}/{props?.totalQuestions}
                </div>
        },
        {
            name: 'Actions',
            cell: (props) =>
                <div className="d-flex">
                    <a onClick={(e) => handleViewResult(e, props)} className="btn btn-sm btn-soft-info" data-bs-toggle="modal" data-bs-target=".transaction-detailModal"><i className="mdi mdi-eye-outline mr-5"></i>View Result</a>
                </div>
        },
    ];

    useEffect(() => {

        if (window.site === undefined) {
            setTimeout(() => {
                if (window.site && window.site.common && window.site.common.imageCloudfront) {
                    setImg(window.site.common.imageCloudfront)
                }
            }, 1000);
        }
        if (window.site && window.site.common && window.site.common.imageCloudfront) {
            setImg(window.site.common.imageCloudfront)
        }


    }, [window.site]);

    useEffect(() => {
        if (!localStorage.getItem("token")) {
            history.push("/admin");
        }

        getQuizInfoId()
    }, []);

    useEffect(() => {
        window.scrollTo(0, 0);
        // let quizinfo = JSON.parse(localStorage.getItem('eq'))
        if (quizinfo) {
            setFormData((prevData) => ({
                ...prevData, // Keep the other fields intact
                name: quizinfo?.name,
               // startDate: quizinfo?.startDate?.length > 16 ? quizinfo?.startDate.slice(0, -8) : quizinfo?.startDate,
                endDate: quizinfo?.endDate?.length > 16 ? quizinfo?.endDate.slice(0, -8) : quizinfo?.endDate,
                quizType: quizinfo?.quizType,
                status: quizinfo?.status
            }));

            announcResult()
        }

    }, [quizinfo]);

    const handleBack = (e) => {
        // GetTimeActivity()
        history.push("/admin/dashboard");
    }

    const handleAddQuiz = (e) => {
        GetTimeActivity()
        const isValid = formvalidation();
        if (isValid) {
            createQuiz(formData);
        }
    }
    function formvalidation() {
        GetTimeActivity()
        let formIsValid = true;

        console.log('form', formData)
        if (formData?.name == "") {
            setError((prevData) => ({
                ...prevData, // Keep the other fields intact
                ["name"]: "Please enter Name", // Update the changed field
            }));
            seterrorDisplay(true)
            setTimeout(function () { seterrorDisplay(false) }, 3000);
            formIsValid = false;
        } else {
            setError((prevData) => ({
                ...prevData, // Keep the other fields intact
                ["name"]: "", // Update the changed field
            }));
        }

        if (formData?.quizType == "") {
            setError((prevData) => ({
                ...prevData, // Keep the other fields intact
                ["quizType"]: "Please select quiz type", // Update the changed field
            }));
            seterrorDisplay(true)
            setTimeout(function () { seterrorDisplay(false) }, 3000);
            formIsValid = false;
        } else {
            setError((prevData) => ({
                ...prevData, // Keep the other fields intact
                ["quizType"]: "", // Update the changed field
            }));
        }

        if (formData?.startDate == "") {

            setError((prevData) => ({
                ...prevData, // Keep the other fields intact
                ["startDate"]: "Please select startDate", // Update the changed field
            }));
            seterrorDisplay(true)
            setTimeout(function () { seterrorDisplay(false) }, 3000);
            formIsValid = false;
        } else {
            setError((prevData) => ({
                ...prevData, // Keep the other fields intact
                ["startDate"]: "", // Update the changed field
            }));
        }

        if (formData?.endDate == "") {
            setError((prevData) => ({
                ...prevData, // Keep the other fields intact
                ["endDate"]: "Please select endDate", // Update the changed field
            }));
            seterrorDisplay(true)
            setTimeout(function () { seterrorDisplay(false) }, 3000);
            formIsValid = false;
        } else {
            setError((prevData) => ({
                ...prevData, // Keep the other fields intact
                ["endDate"]: "", // Update the changed field
            }));
        }

        return formIsValid;
    }

    const handleChange = (event) => {
        const { name, value } = event.target;
        setFormData((prevData) => ({
            ...prevData, // Keep the other fields intact
            [name]: value, // Update the changed field
        }));
    };

    const handleReset = (event) => {

        setFormData((prevData) => ({
            ...prevData, // Keep the other fields intact
            name: quizinfo.name,
            startDate: quizinfo.startDate.slice(0, -8),
            endDate: quizinfo.endDate.slice(0, -8)
        }));
    };



    // Handle row selection
    const handleRowSelected = (state) => {
        setSelectedRows(state.selectedRows);
    };

    // Handle form submission
    const handleSubmit = async (e) => {
        // console.log("Selected Rows:", selectedRows);
        // Perform your submit action (e.g., send data to an API)
        let pids = []
        selectedRows.forEach(item => {
            pids.push(item?.participationid)
        });

        let participants = {
            participationids: pids
        }

        try {
            const response = await tmdbApi.winnerSubmit(participants, quizinfo?.quizid);
            //    console.log(response);
            setUpdateSuccess(true)
        } catch {
            console.log("error");
        }


    };

    const handleAnnounceWinner = (e) => {
        e.preventDefault()
        setAWPopup(!announceWinnerPopup)
    };

    const handleViewResult = async (e, props) => {
        // console.log(props)
        setViewParticipant(props)
        try {
            const response = await tmdbApi.viewResult(props?.participationid);
            // console.log('vvvv', response)
            setViewResult(response?.result);
        } catch {
            console.log("error");
        }
    }

    const announcResult = async () => {
        try {


            const response = await tmdbApi.announceResult(quizinfo?.quizid);
            // console.log(response);
            setAWResult(response?.result);
        } catch {
            console.log("error");
        }
    };

    const getQuizInfoId = async () => {
        try {


            const response = await tmdbApi.quizInfoId(quizid);
            // console.log(response);
            setQuizInfo(response?.result[0]);
        } catch {
            console.log("error");
        }
    };



    const createQuiz = async (formData) => {
        try {
            if (files && files.length > 0) {
                formData["files"] = files
            }

            const response = await tmdbApi.UpdateQuiz(formData, quizinfo?.quizid);
            console.log(response);
            // if (response?.statusCode == 200) {
            setSuccess(true);
            //  }
        } catch {
            console.log("error");
        }
    };

    const onUpdateConfirm = (e) => {
        setUpdateSuccess(false)
        setSelectedRows([])
        setToggleClearRows(!toggleClearRows);
    }

    const onConfirm = () => {
        setSuccess(false);
    };

    const handleBread = () => {
        GetTimeActivity()
        history.push("/usermanagement")
    }


    console.log("veiw", viewResult)

    return (
        <>

            <div id="layout-wrapper">
                <Header />
                <Sidebar />

                <div className="quiz-page main-content user-management create-user">

                    <div className="page-content ">
                        <div className="container-fluid">



                            <div className="row mb-4 breadcrumb">
                                <div className="col-lg-12">
                                    <div className="d-flex align-items-center">

                                        <div className="flex-grow-1">
                                            <h4 className="mb-2 card-title">View Quiz</h4>
                                            <p className="menu-path"><span onClick={handleBread}>Quiz </span> / <b>View Quiz</b> / <b>{quizinfo?.name || formData?.name}</b></p>

                                        </div>
                                        <div>
                                            <a onClick={handleBack} className="btn btn-primary">back</a>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            {!announceWinnerPopup &&
                                <div className="create-user-block">
                                    <div className="form-block">
                                        <div className="row">
                                            <div className="col-md-6">
                                                <div className="col-md-12">
                                                    <div className="mb-3 input-field">
                                                        <label className="form-label form-label">QUIZ NAME</label>
                                                        <input id="name" name="name" placeholder="Enter Your Name" type="text" className="form-control form-control" aria-invalid="false" value={formData?.name} readOnly />

                                                        {errorDisplay && <span className="errormsg" style={{
                                                            fontWeight: 'bold',
                                                            color: 'red',
                                                        }}>{errorData?.name}</span>}

                                                    </div>
                                                </div>

                                                <div className="col-md-6">
                                                    <div className="mb-3 input-field">
                                                        <label className="form-label form-label">QUIZ TYPE</label>

                                                        <select name="quizType" value={formData?.quizType} className="form-control" readOnly>
                                                            <option value="">Select Type</option>
                                                            <option value="Self Assessment">Self Assessment</option>
                                                            <option value="Competitive">Competitive</option>
                                                        </select>


                                                        {errorDisplay && <span className="errormsg" style={{
                                                            fontWeight: 'bold',
                                                            color: 'red',
                                                        }}>{errorData?.quizType}</span>}
                                                    </div>
                                                </div>

                                                {formData?.quizType == "Competitive" &&        
                                                <div className="col-md-6">
                                                    <div className="mb-3 input-field">
                                                        <label className="form-label form-label">END DATE</label>
                                                        <input type="datetime-local" name="endDate" className="form-control form-control" aria-invalid="false" min={new Date().toISOString().slice(0, new Date().toISOString().lastIndexOf(":"))} value={formData?.endDate} readOnly />

                                                        {errorDisplay && <span className="errormsg" style={{
                                                            fontWeight: 'bold',
                                                            color: 'red',
                                                        }}>{errorData?.endDate}</span>}
                                                    </div>
                                                </div>}

                                                <div className="col-md-6">
                                                    <div className="mb-3 input-field">
                                                        <label className="form-label form-label">STATUS</label>

                                                        <select name="status" value={formData?.status} className="form-control" readOnly>
                                                            <option value="">Select Type</option>
                                                            <option value="ACTIVE">ACTIVE</option>
                                                            <option value="INACTIVE">INACTIVE</option>
                                                        </select>


                                                        {errorDisplay && <span className="errormsg" style={{
                                                            fontWeight: 'bold',
                                                            color: 'red',
                                                        }}>{errorData?.status}</span>}
                                                    </div>
                                                </div>

                                                {/* <div className="row">
                                                    <div className="col-md-6">
                                                        <div className="mb-3 input-field">
                                                            <label className="form-label form-label">START DATE</label>
                                                            <input type="datetime-local" name="startDate" className="form-control form-control" aria-invalid="false" min={new Date().toISOString().slice(0, new Date().toISOString().lastIndexOf(":"))} value={formData?.startDate} readOnly />

                                                            {errorDisplay && <span className="errormsg" style={{
                                                                fontWeight: 'bold',
                                                                color: 'red',
                                                            }}>{errorData?.startDate}</span>}
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <div className="mb-3 input-field">
                                                            <label className="form-label form-label">END DATE</label>
                                                            <input type="datetime-local" name="endDate" className="form-control form-control" aria-invalid="false"  min={new Date().toISOString().slice(0, new Date().toISOString().lastIndexOf(":"))} value={formData?.endDate} readOnly />

                                                            {errorDisplay && <span className="errormsg" style={{
                                                                fontWeight: 'bold',
                                                                color: 'red',
                                                            }}>{errorData?.endDate}</span>}
                                                        </div>
                                                    </div>
                                                </div> */}



                                                <div className="col-md-6">
                                                    <div className="mb-3 input-field">
                                                        <label className="form-label form-label">UPLOAD IMAGE</label>
                                                        <div className="upload-zone">
                                                            <div className="upload-icon">
                                                                {!imagedisplay && quizinfo?.files && quizinfo?.files.length > 0 &&
                                                                    <img src={`${imageCloudfront}${quizinfo?.files[0]?.filepath.replace(/ /g, "%20")}?auto=compress,format&width=150`} width="150" />}



                                                            </div>




                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-12">


                                            {quizinfo?.status && <button className="btn btn-primary btn-block btn3 mr-10" onClick={e => handleAnnounceWinner(e)}>{quizinfo?.status == "RESULT PENDING" ? "Announce Winner" : "Participants"}</button>}
                                        </div>
                                    </div>
                                    <SweetAlert show={success}
                                        custom
                                        confirmBtnText="ok"
                                        confirmBtnBsStyle="primary"
                                        title={"Quiz updated successfully"}
                                        onConfirm={e => onConfirm()}
                                    >
                                    </SweetAlert>
                                </div>}

                            {announceWinnerPopup &&
                                <div className="create-user-block">
                                    <h5>Participants</h5>
                                    <div className="admin_winner_block">

                                        {announceWinnerResult && announceWinnerResult?.length > 0 ?
                                            <>
                                                <DataTable
                                                    // title=""
                                                    columns={columns}
                                                    // className="table align-middle table-nowrap table-check"
                                                    // keyField='_id'
                                                    data={announceWinnerResult}
                                                    direction="auto"
                                                    highlightOnHover
                                                    fixedHeaderScrollHeight="300px"
                                                    pagination
                                                    responsive
                                                    persistTableHead
                                                    // selectableRowsVisibleOnly
                                                    striped
                                                    selectableRowsHighlight

                                                    selectableRows={quizinfo?.status == "RESULT PENDING" ? true : false}
                                                    onSelectedRowsChange={handleRowSelected}

                                                    subHeaderAlign="right"
                                                    defaultSortField="name"
                                                    subHeaderWra
                                                    paginationTotalRows={announceWinnerResult?.length}

                                                    paginationRowsPerPageOptions={[15, 25, 50, 75, 100]}


                                                    paginationComponentOptions={{
                                                        rowsPerPageText: 'Per page:',
                                                        rangeSeparatorText: 'of',
                                                        noRowsPerPage: false,
                                                        selectAllRowsItem: false,
                                                        selectAllRowsItemText: 'All',
                                                    }}
                                                    clearSelectedRows={toggleClearRows}
                                                />
                                                <div className="row">
                                                    <div className="col-md-12">


                                                        {quizinfo?.status == "RESULT PENDING" && <button onClick={(e) => handleSubmit(e)} className="btn btn-primary btn-block btn1 " type="submit">Submit</button>}

                                                        <button onClick={(e) => setAWPopup(!announceWinnerPopup)} className="btn btn-primary btn-block btn2 ">Cancel</button>

                                                    </div>
                                                </div>



                                                <div className="modal result-popup fade  transaction-detailModal" tabIndex="-1" role="dialog"
                                                    aria-labelledby="transaction-detailModalLabel" aria-hidden="true">
                                                    <div className="modal-dialog modal-xl modal-dialog-centered" role="document">
                                                        <div className="modal-content">
                                                            <div className="modal-header">
                                                                <h5 className="modal-title">{viewParticipant?.participationDetails?.name} - Result</h5>
                                                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                                                            </div>
                                                            <div className="modal-body">
                                                                <div className="table-responsive">
                                                                    <table className="table db_table">

                                                                        <thead className="table-light">
                                                                            <tr>
                                                                                <th>TITLE</th>
                                                                                <th>QUESTION</th>
                                                                                <th>USER ANSWER</th>
                                                                                <th>ACTUAL ANSWER</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            {viewResult[0]?.quiz && viewResult[0]?.quiz.length > 0 && viewResult[0]?.quiz.map((item, index) => (
                                                                                <tr>
                                                                                    <td>{item?.question}</td>
                                                                                    <td>{parse(item?.description)}</td>
                                                                                    <td>
                                                                                        <span className={item?.actualanswer == item?.answer ? "correct text-success" : "wrong text-danger"}>{item?.answer}</span>

                                                                                    </td>
                                                                                    <td>{item?.actualanswer}</td>


                                                                                </tr>
                                                                            ))}

                                                                        </tbody>
                                                                    </table>
                                                                </div>

                                                            </div>

                                                        </div>
                                                    </div>
                                                </div>
                                            </>
                                            :
                                            <div>
                                                <div className="empty-state-body empty-record"  >
                                                    <div className="empty-state__message">
                                                        <span className="material-icons">summarize</span>
                                                        <p className="form-check font-size-16">No participants found</p>
                                                    </div> </div>
                                            </div>}
                                    </div>

                                    <SweetAlert show={updatesuccess}
                                        custom
                                        confirmBtnText="ok"
                                        confirmBtnBsStyle="primary"
                                        title={"Winner updated successfully"}
                                        onConfirm={e => onUpdateConfirm(e)}
                                    >
                                    </SweetAlert>

                                </div>



                            }


                        </div>
                    </div>



                    <Footer />
                </div>


            </div>

        </>
    );
};

export default View;
